import axios from "axios";
import { auth } from '../firebase';

export const http = axios.create({
  baseURL: "https://aomapi-production.up.railway.app/",
  //baseURL: ""
  //baseURL: "http://localhost:8081/"
});

// Resolves once Firebase determines the initial auth state (prevents race condition on startup)
const authInitialized = new Promise(resolve => {
  const unsubscribe = auth.onAuthStateChanged(user => {
    unsubscribe();
    resolve(user);
  });
});

http.interceptors.request.use(async config => {
  try {
    await authInitialized;
    const user = auth.currentUser;

    if (user) {
      const idToken = await user.getIdToken();
      config.headers.Authorization = `Bearer ${idToken}`;
    } else {
      const idToken = localStorage.getItem('idToken');
      if (idToken) {
        config.headers.Authorization = `Bearer ${idToken}`;
      }
    }
  } catch (error) {
    console.error("Erro ao renovar token do Firebase", error);
  }

  return config;
}, error => {
  return Promise.reject(error);
});

export default http;